import "./config";

import App from "./widgets/App";

import "./analytics"

/**
 * Initialize application
 */
export const app = new App({
  appName: "IROADS - Illinois Roadway Analysis Database System",
  appNotice: "IROADS WILL BE UNAVAILABILE ON SAT. AUGUST 19th FROM 8 AM UNTIL 12 PM",
  appNoticeStart: "8/18/2023 12:00 GMT-0500",
  appNoticeEnd: "8/19/2023 12:00 GMT-0500",
  container: document.getElementById("app") as HTMLElement
});
